<template>
  <div>
    <PageHeader page-name="Бегущая строка">
      <template>
        <router-link :to="{name: 'CreateRunningLine'}">
          <el-button type="primary">
            Добавить баннер для бегущей строки
          </el-button>
        </router-link>
      </template>
    </PageHeader>
    <MainPanel>
      <List v-loading="loading" />
    </MainPanel>
  </div>
</template>

<script>
import {mapActions} from 'vuex'
import List from '@/components/running-line/List'
import MainPanel from '@/components/common/MainPanel'
import PageHeader from '@/components/common/PageHeader';

export default {
  name: 'RunningLineListPage',
  components: {MainPanel, List, PageHeader},
  metaInfo: {
    title: 'Бегущая строка',
  },
  data() {
    return {
      loading: false,
    }
  },
  async mounted() {
    this.loading = true
    await this.getModel()
    this.loading = false
  },
  methods: {
    ...mapActions('runningLines', {
      getModel: 'fetchRunningLinesList',
    }),
  },
}
</script>

<style lang="sass" scoped>
.running-line-list
  padding: 20px

.running-line-list__header
  display: flex
  justify-content: space-between
  align-items: center
  margin-bottom: 20px

.running-line-list__title
  margin: 0
  font-size: 24px
  font-weight: 500

.running-line-list__table
  margin-top: 20px

.running-line-list__image
  max-width: 50px
  max-height: 50px
  object-fit: contain
</style>



